import { defineMessages } from "react-intl";

export const messages = defineMessages({
  point1: {
    id: "downloadEntities.modal.info.point1",
    defaultMessage: "Any columns currently selected",
    description: "Download entities modal - info - point 1",
  },
  point2: {
    id: "downloadEntities.modal.info.point2",
    defaultMessage: "Any filters currently applied",
    description: "Download entities modal - info - point 2",
  },
  point2withAdditionalFilters: {
    id: "downloadEntities.modal.info.point2withAdditionalFilters",
    defaultMessage: "Any filters and additional criteria currently applied",
    description: "Download entities modal - info - point 2 with additional filters",
  },
});
